export default __webpack_public_path__ + "static/media/Service-Background3.cd46adab.png";